import { PositionData } from "@org-avp/avp-avengers-projectstructure-service-api";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const posDataSelectionProjectStructureSliceName = "posDataSelectionProjectStructure";

export interface PosDataSelectionProjectStructureState {
  selectedPosData: PositionData[];
}

const initialState: PosDataSelectionProjectStructureState = {
  selectedPosData: [],
};

const posDataSelectionSlice = createSlice({
  name: posDataSelectionProjectStructureSliceName,
  initialState,
  reducers: {
    setPosDataSelection(state: PosDataSelectionProjectStructureState, action: PayloadAction<PositionData[]>) {
      state.selectedPosData = action.payload;
    },
  },
});

export interface PosDataSelectionProjectStructureRootState {
  [posDataSelectionProjectStructureSliceName]: PosDataSelectionProjectStructureState;
}

export const selectPosData = (state: PosDataSelectionProjectStructureRootState) => state[posDataSelectionProjectStructureSliceName];
export const selectPosDataSelection = (state: PosDataSelectionProjectStructureRootState) => {
  return selectPosData(state).selectedPosData;
};

export const { setPosDataSelection } = posDataSelectionSlice.actions;
export const posDataSelectionProjectStructureReducer = posDataSelectionSlice.reducer;
